import React from 'react'
import useClickOutside from '../hooks/useClickOutside';
import Sidebar from '../components/home/sidebar';
interface SidebarProps {
    sidebarDisplay: boolean;
    setSidebarDisplay: React.Dispatch<React.SetStateAction<boolean>>;
}
const SidebarComponent = ({ sidebarDisplay, setSidebarDisplay }: SidebarProps) => {
    const ref = React.useRef<HTMLDivElement>(null);
    useClickOutside(ref, () => {
        setSidebarDisplay(false);
    });
    if (!sidebarDisplay) return null;
    return (
        <div className='w-[100vw] h-100-vh-safe  fixed top-0 bottom-0 left-0   z-10 flex flex-col overflow-hidden'>
            <div ref={ref} className={`h-100-vh-safe w-[200px] md:w-[250px] bg-white dark:bg-[#202020]  flex flex-col overflow-hidden`}>
                <Sidebar
                    sidebarDisplay={sidebarDisplay}
                    isAdsVisible={true}
                />
            </div>
        </div>
    )
}

export default SidebarComponent